<!-- eslint-disable -->
<template>
  <div id="onlinestate">
    <div class="row align-items-start pb-2">
      <div class="col-2">
        <button
          type="button"
          @click.prevent="onButtonOnlineRefresh"
          class="btn btn-outline-success"
        >
          Online-Status aktualisieren
        </button>
      </div>                    
      <div class="col-2">
      <div class="div" v-if="isSyncInProgress">
        <p>Aktualisierung läuft ...</p>
      </div>
      </div>         
      <div class="col-2">
        <button
          type="button"
          @click.prevent="onButtonOnlineClick"
          class="btn btn-outline-primary"
        >
          Geräte-Status anzeigen
        </button>
      </div>  
      <div class="col-6"></div>       
    </div>
    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '540px' }"
          :data-items="filteredData"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          @filterchange="filterChange"
          @sortchange="sortChange"
          :filter-cell-render="filterRender"
          @custom="customHandler"
        >
          <template v-slot:myTemplate="{ props }">
            <cell-container :data-item="props.dataItem" />
          </template>
          <template v-slot:filterSlotTemplate="{ props, methods }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 120px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
        </Grid>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import CellContainer from "@/components/ControlCenter/CellContainer";
import { AreaStore } from "@/store/modules/areastore"
import { UserStore } from "@/store/modules/userstore"
 
export default {
  name: "DeviceOnlineState",
  inheritAttrs: false,
  components: {
    Grid,
    CellContainer,
  },
  data: function () {
    return {
      timerId: {},
      isSyncStarted: false,
      isSyncInProgress: false,
      filter: {},
      filteredData: [],
      originData: [],
      staticColumns: [
        {
          field: "idMonitoring",
          title: "IdMonitoring",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "fkGeaet",
          title: "fkGeaet",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "fkBereich",
          title: "fkBereich",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "auswerteStatus",
          title: "Status",
          filterable: false,
          sortable: false,
          width: "50px",
          cell: "myTemplate",
        },
        {
          field: "nameMandant",
          title: "NameMandant",
          filterCell: "filterSlotTemplate",
          width: "300px",
          hidden: true,
        },
        {
          field: "nameBereich",
          title: "Bereich",
          filterCell: "filterSlotTemplate",
          width: "280px",
        },
        {
          field: "hinweis",
          title: "Hinweis",
          filterCell: "filterSlotTemplate",
          width: "350px",
        },
        {
          field: "nameGeraet",
          title: "NameGeraet",
          filterCell: "filterSlotTemplate",
          width: "250px",
        },
        {
          field: "imeiNr",
          title: "ImeiNr",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "telNrGeraet",
          title: "TelNrGeraet",
          filterCell: "filterSlotTemplate",
          width: "200px",
        },
        {
          field: "typ",
          title: "Typ",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "quelle",
          title: "Quelle",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "empfangQuelle",
          title: "Empfang-Quelle",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "keyForIdentification",
          title: "KeyForIdentification",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "zumGeraetInhalt",
          title: "ZumGeraetInhalt",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "zumGeraetDatumZeit",
          title: "ZumGeraetDatumZeit",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "zumGeraetBestaetigt",
          title: "ZumGeraetBestaetigt",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "vomGeraetInhalt",
          title: "VomGeraetInhalt",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "vomGeraetDatumZeit",
          title: "VomGeraetDatumZeit",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "vomGeraetBestaetigt",
          title: "VomGeraetBestaetigt",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "geraeteStatus",
          title: "GeraeteStatus",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "onlineStatus",
          title: "OnlineStatus",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "letzteOfflineModeErkennung",
          title: "LetzteOfflineModeErkennung",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "letzerHeartBeat",
          title: "LetzerHeartBeat",
          filterable: false,
          width: "200px",
        },
        {
          field: "letzerHeartBeatBestaetigt",
          title: "LetzerHeartBeatBestaetigt",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "matchBedingung",
          title: "MatchBedingung",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "verbunden",
          title: "Verbunden",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "getrennt",
          title: "Getrennt",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "zumGeraetQuelle",
          title: "ZumGeraetQuelle",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
        {
          field: "vomGeraetQuelle",
          title: "VomGeraetQuelle",
          filterCell: "filterSlotTemplate",
          width: "200px",
          filterable: false,
          sortable: false,
          hidden: true,
        },
      ],
    };
  },
  computed: {
    columns() {
      return [...this.staticColumns];
    },
  },
  mounted() {
    this.isSyncInProgress = false
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let self = this;
    this.timerId = setInterval(() => { self.isSync() }, 10000)    
  },
  unmounted() {
    try {
      clearInterval(this.timerId)
    }
    catch(e) {
      console.log(e)
    }
  },
  methods: {
    async isSync() {
       const temp = await apiPost("ComponentView/isSyncStarted", {
       userId: this.$store.getters["userstore/getUser"],
      });
      this.isSyncInProgress = temp.isSyncStarted
    },
    onButtonOnlineClick() {
      this.getData();
    },
    onButtonOnlineRefresh() {
      this.refreshData();
    },
    filterChange: function (ev) {
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },
    getAreas() {
      const areaInfo = this.$store.getters["areastore/getDataSet"];
      const areas = [];
      for (let i = 0; i < areaInfo.areas.length; i++) {
        areas.push(areaInfo.areas[i]["idBereich"]);
      }
      return areas
    },
    getDevices() {
      const deviceInfo = this.$store.getters["devicestore/getDataSet"];
      const devices = [];
      for (let i = 0; i < deviceInfo.devices.length; i++) {
        devices.push(deviceInfo.devices[i]["idGeraet"]);
      }
      return devices
    },
    async getData() {
      const temp = await apiPost("ComponentView/viewDeviceOnlineState", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
        geraete: this.getDevices()
      });
      this.filteredData = temp.map((item) => {
        return { ...item };
      });
      this.originData = temp.map((item) => {
        return { ...item };
      });
    },
    async refreshData() {
      this.isSyncInProgress = true
      const temp = await apiPost("ComponentView/refreshDeviceOnlineState", {
        userId: this.$store.getters["userstore/getUser"],
        bereiche: this.getAreas(),
        geraete: this.getDevices()
      });
    },
    customHandler: function (e) {
      console.log("customHandler", e);
    },
  },
};
</script>

<style scoped language="scss">
.k-grid {
  font-size: 12px !important;
}
</style>